"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93],{

/***/ 12433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OD": function() { return /* binding */ Lozenge; }
/* harmony export */ });
/* unused harmony exports rotationClasses, sizeClasses */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51123);



var rotationClasses = {
    1: "rotate-[30deg]",
    2: "rotate-[60deg]",
    3: "rotate-[90deg]",
    4: "rotate-[120deg]",
    5: "rotate-[150deg]",
    6: "rotate-[180deg]",
    7: "rotate-[210deg]",
    8: "rotate-[240deg]",
    9: "rotate-[270deg]",
    10: "rotate-[300deg]",
    11: "rotate-[330deg]",
    12: "rotate-[360deg]"
};
var sizeClasses = {
    sm: "w-[52px] h-[92px]",
    md: "w-[82px] h-[147px]",
    lg: "w-[117px] h-[209px]",
    xl: "w-[141px] h-[252px]"
};
var Lozenge = function(param) {
    var color = param.color, size = param.size, rotation = param.rotation, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_colors__WEBPACK_IMPORTED_MODULE_2__/* .backgroundClasses */ .b0[color], sizeClasses[size], rotationClasses[rotation], "scale-[40%] tablet:scale-[60%] lg:scale-75 xl:scale-90 2xl:scale-100", "origin-center block rounded-full", className)
    });
};


/***/ }),

/***/ 7693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ One; }
/* harmony export */ });
/* unused harmony export rotationClasses */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var FILES = {
    "brand-base": "/decorations/one-brand-base.svg",
    "blue-base": "/decorations/one-blue-base.svg",
    "green-base": "/decorations/one-green-base.svg",
    "lilac-base": "/decorations/one-lilac-base.svg",
    "coral-base": "/decorations/one-coral-base.svg"
};
var rotationClasses = {
    up: "rotate-[15deg]",
    down: "rotate-[205deg]"
};
var One = function(param) {
    var _color = param.color, color = _color === void 0 ? "brand-base" : _color, _direction = param.direction, direction = _direction === void 0 ? "up" : _direction, className = param.className;
    if (!color || !FILES[color]) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: FILES[color],
        alt: "",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(rotationClasses[direction], className)
    });
};


/***/ }),

/***/ 55237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports ALIGN_OPTIONS, SIZE_OPTIONS, FONT_OPTIONS, TextMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var ALIGN_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .ALIGNMENTS */ .Eu, "left", "center", "right", "auto");
var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "sm", "md", "lg", "xl", "2xl");
var FONT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONTS */ .g5, "heading", "sans", "mono");
var alignClasses = {
    auto: "",
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto"
};
var sizeClasses = {
    sm: "prose-sm md:prose-md",
    md: "prose-md md:prose-base",
    lg: "prose-lg md:prose-xl",
    xl: "prose-lg md:prose-2xl",
    "2xl": "prose-lg md:prose-2xl xl:prose-3xl"
};
var fontClasses = {
    sans: "font-sans",
    mono: "font-mono",
    heading: "font-sans"
};
var Text = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "div" : _as, background = param.background, color = param.color, _align = param.align, align = _align === void 0 ? "left" : _align, _size = param.size, size = _size === void 0 ? "lg" : _size, className = param.className, _font = param.font, font = _font === void 0 ? "sans" : _font;
    var Element = as;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words prose font-regular leading-relaxed", "prose-strong:font-bold prose-strong:text-current", "prose-a:underline prose-a:underline-offset-4", alignClasses[align], sizeClasses[size], fontClasses[font], color ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color] : background ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .proseClasses */ .fh[background] : "text-current", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "prose-a:text-action-base", !background || background === "white" || background === "neutral-95")),
            children: children
        })
    });
};
var TextMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Text)));


/***/ }),

/***/ 37794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; }
/* harmony export */ });
/* unused harmony exports SIZE_OPTIONS, WEIGHT_OPTIONS, TitleMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl");
var WEIGHT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONT_WEIGHTS */ .Xw, "book", "bold");
var sizeClasses = {
    xs: "text-title-xs-sm md:text-title-xs-md lg:text-title-xs-lg",
    sm: "text-title-sm-sm md:text-title-sm-md lg:text-title-sm-lg",
    md: "text-title-md-sm md:text-title-md-md lg:text-title-md-lg",
    lg: "text-title-lg-sm md:text-title-lg-md lg:text-title-lg-lg",
    xl: "text-title-xl-sm md:text-title-xl-md lg:text-title-xl-lg",
    "2xl": "text-title-2xl-sm md:text-title-2xl-md lg:text-title-2xl-lg",
    "3xl": "text-title-3xl-sm md:text-title-3xl-md lg:text-title-3xl-lg",
    "4xl": "text-title-4xl-sm md:text-title-4xl-md lg:text-title-4xl-lg"
};
var weightClasses = {
    book: "font-book",
    bold: "font-bold"
};
var Title = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "h2" : _as, _size = param.size, size = _size === void 0 ? "sm" : _size, _weight = param.weight, weight = _weight === void 0 ? "bold" : _weight, className = param.className, _color = param.color, color = _color === void 0 ? "neutral-base" : _color, eyebrow = param.eyebrow, _eyebrowColor = param.eyebrowColor, eyebrowColor = _eyebrowColor === void 0 ? "brand-base" : _eyebrowColor;
    var ref;
    var Element = as;
    var titleWords = (ref = children === null || children === void 0 ? void 0 : children.toString()) === null || ref === void 0 ? void 0 : ref.trim().split(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            eyebrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block mb-[.5em]", sizeClasses.md, _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[eyebrowColor], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "opacity-75", eyebrowColor === "white")),
                children: [
                    eyebrow,
                    "\xa0"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words inline-block", "font-sans", "flex flex-col whitespace-pre-line", _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color], sizeClasses[size], weightClasses[weight], className),
                children: typeof children === "string" ? titleWords.join(" ") : children
            })
        ]
    });
};
var TitleMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Title)));


/***/ }),

/***/ 37138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RichText": function() { return /* binding */ RichText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12433);
/* harmony import */ var _components_Decorations_One__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7693);
/* harmony import */ var _components_module_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55237);
/* harmony import */ var _components_module_Title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37794);
/* harmony import */ var _components_module_Wrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83118);









var RichText = function(param) {
    var eyebrow = param.eyebrow, title = param.title, content = param.content, theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    // dark background scenario: change overal colouring
    var titleColor = "neutral-base";
    var textColor = "neutral-25";
    var eyebrowColor = "brand-base";
    var isDarkBackground = false;
    if ((theme === null || theme === void 0 ? void 0 : (ref = theme.module) === null || ref === void 0 ? void 0 : ref.background) === "brand-dark" || (theme === null || theme === void 0 ? void 0 : (ref1 = theme.module) === null || ref1 === void 0 ? void 0 : ref1.background) === "brand-base" || (theme === null || theme === void 0 ? void 0 : (ref2 = theme.module) === null || ref2 === void 0 ? void 0 : ref2.background) === "blue-dark" || (theme === null || theme === void 0 ? void 0 : (ref3 = theme.module) === null || ref3 === void 0 ? void 0 : ref3.background) === "green-dark" || (theme === null || theme === void 0 ? void 0 : (ref4 = theme.module) === null || ref4 === void 0 ? void 0 : ref4.background) === "black" || (theme === null || theme === void 0 ? void 0 : (ref5 = theme.module) === null || ref5 === void 0 ? void 0 : ref5.background) === "coral-dark" || (theme === null || theme === void 0 ? void 0 : (ref6 = theme.module) === null || ref6 === void 0 ? void 0 : ref6.background) === "lilac-dark") {
        var ref30, ref31;
        isDarkBackground = true;
        titleColor = "white";
        textColor = "white";
        eyebrowColor = "brand-light";
        if ((theme === null || theme === void 0 ? void 0 : (ref30 = theme.module) === null || ref30 === void 0 ? void 0 : ref30.background) === "blue-dark" || (theme === null || theme === void 0 ? void 0 : (ref31 = theme.module) === null || ref31 === void 0 ? void 0 : ref31.background) === "green-dark") {
            eyebrowColor = "white";
        }
    }
    var oneColor = "brand-base";
    if ((theme === null || theme === void 0 ? void 0 : (ref7 = theme.module) === null || ref7 === void 0 ? void 0 : ref7.background) === "lilac-dark") {
        oneColor = "lilac-base";
    }
    if ((theme === null || theme === void 0 ? void 0 : (ref8 = theme.module) === null || ref8 === void 0 ? void 0 : ref8.background) === "blue-dark") {
        oneColor = "blue-base";
    }
    if ((theme === null || theme === void 0 ? void 0 : (ref9 = theme.module) === null || ref9 === void 0 ? void 0 : ref9.background) === "green-dark") {
        oneColor = "green-base";
    }
    if ((theme === null || theme === void 0 ? void 0 : (ref10 = theme.module) === null || ref10 === void 0 ? void 0 : ref10.background) === "coral-dark") {
        oneColor = "coral-base";
    }
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_module_Wrapper__WEBPACK_IMPORTED_MODULE_7__/* .Wrapper */ .i, {
        theme: {
            width: theme === null || theme === void 0 ? void 0 : (ref11 = theme.module) === null || ref11 === void 0 ? void 0 : ref11.width,
            background: theme === null || theme === void 0 ? void 0 : (ref12 = theme.module) === null || ref12 === void 0 ? void 0 : ref12.background,
            space: theme === null || theme === void 0 ? void 0 : (ref13 = theme.module) === null || ref13 === void 0 ? void 0 : ref13.space,
            pullUp: theme === null || theme === void 0 ? void 0 : (ref14 = theme.module) === null || ref14 === void 0 ? void 0 : ref14.pullUp,
            rounded: {
                top: theme === null || theme === void 0 ? void 0 : (ref15 = theme.decorations) === null || ref15 === void 0 ? void 0 : ref15.roundedTop,
                bottom: theme === null || theme === void 0 ? void 0 : (ref16 = theme.decorations) === null || ref16 === void 0 ? void 0 : ref16.roundedBottom
            }
        },
        className: "relative",
        innerClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()("overflow-hidden", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, "bg-gradient-to-tr from-brand-dark to-brand-base", (theme === null || theme === void 0 ? void 0 : (ref17 = theme.module) === null || ref17 === void 0 ? void 0 : ref17.background) === "brand-base")),
        children: [
            ((theme === null || theme === void 0 ? void 0 : (ref18 = theme.decorations) === null || ref18 === void 0 ? void 0 : ref18.showOnes) || (theme === null || theme === void 0 ? void 0 : (ref19 = theme.decorations) === null || ref19 === void 0 ? void 0 : ref19.showLozenges)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "absolute inset-0 hidden md:block pointer-events-none",
                children: [
                    (theme === null || theme === void 0 ? void 0 : (ref20 = theme.decorations) === null || ref20 === void 0 ? void 0 : ref20.showOnes) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_One__WEBPACK_IMPORTED_MODULE_4__/* .One */ .f, {
                                direction: "up",
                                color: oneColor,
                                className: "absolute top-20 left-0 scale-75 xl:scale-100 -translate-x-[95%] xl:-translate-x-[100%] 2xl:-translate-x-[77%]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_One__WEBPACK_IMPORTED_MODULE_4__/* .One */ .f, {
                                direction: "down",
                                color: oneColor,
                                className: "absolute right-0 -bottom-16 scale-75 xl:scale-100 translate-x-[100%] 2xl:translate-x-[88%]"
                            })
                        ]
                    }),
                    (theme === null || theme === void 0 ? void 0 : (ref21 = theme.decorations) === null || ref21 === void 0 ? void 0 : ref21.showLozenges) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_3__/* .Lozenge */ .OD, {
                                color: (theme === null || theme === void 0 ? void 0 : (ref22 = theme.module) === null || ref22 === void 0 ? void 0 : ref22.background) === "neutral-95" ? "white" : "neutral-95",
                                size: "lg",
                                rotation: 11,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute right-0 md:right-[10%] top-0 md:top-[10%]", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, "opacity-10", isDarkBackground))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_3__/* .Lozenge */ .OD, {
                                color: (theme === null || theme === void 0 ? void 0 : (ref23 = theme.module) === null || ref23 === void 0 ? void 0 : ref23.background) === "brand-dark" ? "white" : "action-light",
                                size: "md",
                                rotation: 2,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute hidden md:block left-[10%] top-[50%]", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, "opacity-10", isDarkBackground))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("z-20 relative", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, "py-8 sm:py-10 lg:py-16 xl:py-30", theme === null || theme === void 0 ? void 0 : (ref24 = theme.module) === null || ref24 === void 0 ? void 0 : ref24.background)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("max-w-title flex flex-col gap-8", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "md:text-left", (theme === null || theme === void 0 ? void 0 : (ref25 = theme.module) === null || ref25 === void 0 ? void 0 : ref25.align) === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "md:text-center md:mx-auto", (theme === null || theme === void 0 ? void 0 : (ref26 = theme.module) === null || ref26 === void 0 ? void 0 : ref26.align) === "center"), _obj)),
                    children: [
                        (Boolean(title === null || title === void 0 ? void 0 : title.trim().length) || Boolean(eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.trim().length)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Title__WEBPACK_IMPORTED_MODULE_6__/* .Title */ .Dx, {
                            size: (theme === null || theme === void 0 ? void 0 : (ref27 = theme.title) === null || ref27 === void 0 ? void 0 : ref27.size) || "3xl",
                            eyebrow: eyebrow,
                            color: titleColor,
                            eyebrowColor: eyebrowColor,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Text__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                            align: null,
                            background: (theme === null || theme === void 0 ? void 0 : (ref28 = theme.module) === null || ref28 === void 0 ? void 0 : ref28.background) || "white",
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, "md:mx-auto", (theme === null || theme === void 0 ? void 0 : (ref29 = theme.module) === null || ref29 === void 0 ? void 0 : ref29.align) === "center")),
                            children: content
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(RichText));


/***/ })

}]);